import type { GraffitiStroke } from "./api";

/** Logical drawing space; the editor and this viewer must agree on it. */
export const GRAFFITI_W = 360;
export const GRAFFITI_H = 300;

/** Render stored graffiti strokes as an SVG, in the space they were drawn in. */
export function GraffitiView({ strokes }: { strokes: GraffitiStroke[] }) {
  return (
    <svg
      className="graffiti-svg"
      viewBox={`0 0 ${GRAFFITI_W} ${GRAFFITI_H}`}
      preserveAspectRatio="xMidYMid meet"
    >
      {strokes.map((s, i) => (
        <polyline
          key={i}
          points={s.points.map((p) => `${p[0]},${p[1]}`).join(" ")}
          fill="none"
          stroke={s.color}
          strokeWidth={s.width}
          strokeOpacity={s.opacity ?? 1}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      ))}
    </svg>
  );
}
